export type PublicPage = "home" | "privacy" | "terms" | "support";

export function publicPageFromPath(pathname: string): PublicPage | null {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  switch (normalized) {
    case "/":
      return "home";
    case "/privacy":
      return "privacy";
    case "/terms":
      return "terms";
    case "/support":
      return "support";
    default:
      return null;
  }
}
